import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';
import styles from "../css/gis.module.css"

// export const PopupViewSurf = ({ item }) => {
//     const [transitionIn, setTransitionIn] = React.useState(false)

//     React.useEffect(() => {
//         setTransitionIn(false)
//         const key = setTimeout(() => {  
//             setTransitionIn(true)
//         }, 400);

//         return () => clearTimeout(key)
//     }, [item])

//     return (
//         <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
//             <div className={`${styles.gisPopup_surf} gisPopup flx flx_col gap6`} style={{width:'520px'}}>
//                 <div className='flx a_center'>
//                     <div className='popTit'>노면</div>
//                     <span className='id'>{item.nm}</span>
//                 </div>
//                 <div className='flx a_center j_spc_btw'>
//                     <div className='flx flx_col j_spc_btw gap20'>
//                         <div className='flx a_center w_100'>
//                             <div className='popTit'>상태</div>
//                             {item.stat == 1 ? <div className='gr popTxt'>정상</div> : <div className='rd popTxt'>장애</div>}
//                         </div>
//                         <div className='flx a_center w_100'>
//                             <div className='popTit'>ID</div>
//                             <div className='popTit'>{item.id}</div>
//                         </div>
//                     </div>
//                     <div style={{width:'40%'}}>
//                         <img style={{width:'100%', height:'100%'}} src='/images/facility/surf_thumbnail.jpg'/>
//                     </div>
//                 </div>
//             </div>
//         </Zoom>
//     )
// }

export const PopupViewSurf = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)
    
    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {
              setTransitionIn(true)
        }, 400);
        
        return () => clearTimeout(key)
    }, [item])
    
    const getStatusInfo = () => {
        const roadStat = item.roadStat;
        
        switch(roadStat) {
            case "001":
                return { text: 'DRY', className: 'gr' };
            case "003":
                return { text: 'WET', className: 'yl' };
            case "006":
                return { text: 'ICE', className: 'bl' };
            case "009":
                return { text: '통신장애', className: 'rd' };
            default:
                return { text: 'DRY', className: 'gr' }; 
        }
    }
    
    const statusInfo = getStatusInfo();
    
    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${styles.gisPopup_surf} gisPopup flx flx_col gap6`} style={{width:'520px'}}>
                <div className='flx a_center'>
                    <div className='popTit'>노면</div>
                    <span className='id'>{item.nm}</span>
                </div>
                <div className='flx a_center j_spc_btw'>
                    <div className='flx flx_col j_spc_btw gap20'>
                        <div className='flx a_center w_100'>
                            <div className='popTit'>상태</div>
                            <div className={`${statusInfo.className} popTxt`}>{statusInfo.text}</div>
                        </div>
                        <div className='flx a_center w_100'>
                            <div className='popTit'>ID</div>
                            <div className='popTit'>{item.id}</div>
                        </div>
                    </div>
                    <div style={{width:'40%'}}>
                        <img style={{width:'100%', height:'100%'}} src='/images/facility/surf_thumbnail.jpg'/>
                    </div>
                </div>
            </div>
        </Zoom>
    )
}